
export const withLang = (lang, path = "") =>
    `/${lang}${path.startsWith("/") ? path : `/${path}`}`.replace(/\/+$/, "").replace(/\/\//g, "/");
